/**
 * 统一环境配置模块
 * 优先读取 CRA 环境变量（.env.development / .env.production），
 * 回退到硬编码默认值，确保任何环境均可运行。
 */

const envConfig = {
  // 当前环境标识：dev / staging / production
  env: process.env.REACT_APP_ENV || 'dev',

  // API 基础地址（Gateway 入口 + 默认路径前缀）
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL
    ? `${process.env.REACT_APP_API_BASE_URL}/api/v1`
    : 'http://localhost:8080/api/v1',

  // WebSocket 地址
  wsBaseUrl: process.env.REACT_APP_WS_BASE_URL || 'ws://localhost:8080/ws/chat',

  // CDN / 文件访问基础地址
  cdnBaseUrl: process.env.REACT_APP_CDN_BASE_URL || 'http://115.190.251.147:9000/kct-ai',

  // 客户端类型：管理端 web / 医院端 web_hospital
  clientType: process.env.REACT_APP_CLIENT_TYPE || 'web',

  // 是否开启日志
  enableLogging: process.env.REACT_APP_ENABLE_LOGGING === 'true',

  // 请求超时（ms）
  apiTimeout: 30000,
};

/**
 * API 路径前缀常量
 * 开发环境和生产环境路径前缀完全一致，由 Gateway 统一路由
 */
export const API_PREFIX = {
  // 标准服务前缀（带服务名）
  user: '/user/api/v1',
  institution: '/institution/api/v1',
  agent: '/agent/api/v1',
  conversation: '/conversation/api/v1',
  knowledge: '/knowledge/api/v1',
  risk: '/risk/api/v1',
  settlement: '/settlement/api/v1',
  notification: '/notification/api/v1',

  // 管理端/医院端专用前缀（无服务名前缀）
  auth: '/api/v1/auth',
  admin: '/api/v1/admin',
  dashboard: '/api/v1/dashboard',
  finance: '/api/v1/finance',
  operators: '/api/v1/operators',
  hospital: '/api/v1/hospital',
  hospitals: '/api/v1/hospitals',
  roles: '/api/v1/roles',
  permissions: '/api/v1/permissions',
  rentalLinks: '/api/v1/rental-links',
  riskRules: '/api/v1/risk-rules',
  monitor: '/api/v1/monitor',
  complaints: '/api/v1/complaints',
  articles: '/api/v1/articles',
  knowledgeApi: '/api/v1/knowledge',
  conversations: '/api/v1/conversations',
  customers: '/api/v1/customers',
  crossHospitalStats: '/api/v1/cross-hospital-stats',
  hospitalCustomers: '/api/v1/hospital-customers',

  // 渠道管理前缀
  channel: '/institution/api/v1/channel',
  channelAdmin: '/institution/api/v1/channel/admin',

  // 结算管理短路径
  bills: '/api/v1/bills',
  recharge: '/api/v1/recharge',
  withdrawals: '/api/v1/withdrawals',
  accounts: '/api/v1/accounts',
  adminSettlement: '/api/v1/admin/settlement',

  // 短路径
  adminShort: '/admin',
  role: '/role',
  article: '/article',
  customer: '/customer',
  followup: '/followup',
  task: '/task',
};

/**
 * 网络配置
 */
export const NETWORK = {
  apiTimeout: 30000,
  wsHeartbeatInterval: 30000,
  wsReconnectInterval: 3000,
  wsMaxReconnectAttempts: 10,
};

/**
 * 拼接文件完整访问 URL
 * 若 path 已是完整 URL 则直接返回，否则拼接 CDN 基础地址
 */
export const fileUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${envConfig.cdnBaseUrl}/${path}`;
};

export { envConfig };
export default envConfig;
